module.exports = __webpack_public_path__ + "static/img/banner.8a562b1.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/banner.png
// module id = jxfV
// module chunks = 0